import { useMemo } from 'react'
import { checkIsInOperatingHoursRange, processOperatingHoursToRanges } from './utils'
import { useOperatingHours } from './useOperatingHours'

export const useOperatingHoursRanges = ({
  initialDate,
  serviceType,
  shouldSkip = false,
}: {
  initialDate?: Date
  serviceType?: string
  shouldSkip?: boolean
}) => {
  const { operatingHoursData, checkServiceHasOperatingHours } = useOperatingHours(serviceType)

  const baseDate = useMemo(() => new Date(initialDate || Date.now()), [initialDate])

  const serviceOperatingHoursData = operatingHoursData?.[serviceType]

  const operatingHoursRanges = useMemo(
    () =>
      shouldSkip || !checkServiceHasOperatingHours(serviceType)?.hasOperatingHours
        ? []
        : processOperatingHoursToRanges(serviceOperatingHoursData, baseDate),
    [baseDate, checkServiceHasOperatingHours, serviceType, serviceOperatingHoursData, shouldSkip],
  )

  const isInOperatingHoursRange = useMemo(
    () => checkIsInOperatingHoursRange(operatingHoursRanges, baseDate),
    [baseDate, operatingHoursRanges],
  )

  return { operatingHoursRanges, isInOperatingHoursRange }
}
